  <dx-button text="Change Backing Pump" (onClick)="changeBackingPump()"></dx-button>
  <div class="pcc-field">
    <div class="pcc-field-label">Name</div>
    <div class="pcc-field-text-value">
      <dx-text-box [(value)]="backingPump.name" readOnly="true" style="background:#EAF4F5;border:none">
      </dx-text-box>
    </div>
    <div class="pcc-field-error">
      {{errors[error.backingpump]}}
    </div>
  </div>
  <div class="pcc-field">
    <div class="pcc-field-label">Valid for Gas</div>
    <div class="pcc-field-text-value">
      <dx-text-box [(value)]="backingPump.gas" readOnly="true" style="background:#EAF4F5;border:none">
      </dx-text-box>
    </div>
    <div class="pcc-field-error">
      {{errors[error.backingpump]}}
    </div>
  </div>
  <div class="pcc-field">
    <div class="pcc-field-label">Number in Parallel</div>
    <div class="pcc-field-value">
      <dx-number-box
        [(value)]="backingPump.parallel"
        [showSpinButtons]="true"
        [showClearButton]="false"
        [min]="0.1" 
        [max]="100"
        (onValueChanged)="announceChange()"></dx-number-box>
    </div>
  </div>
  <div class="pcc-field-error">
    {{errors[error.backingpumpparallel]}}
  </div>
